import { Button, notification } from 'antd';
import React, { useRef, useImperativeHandle } from 'react';
import HelpCenter from '../../../services/HelpCenterJwt';
import api from '../../../services/api';
import LifePreserverIcon from '../../../components/icons/LifePreserver.svg'


async function fetchHelpCentreJwt(): Promise<boolean> {
  try {
    const res = await api.get('/v1/users/help-center-token');
    HelpCenter.set(res.data.token);
    return true;
  } catch (error) {
    console.error('Error fetching Help Center JWT:', error);
    return false;
  }
}

function HelpCenterButtonIcon() {
  return (
    <span className='anticon'>
      <LifePreserverIcon />
    </span>
  )
}

type HelpCenterFormProps = {
  target: "_blank" | "_self" | "_parent" | "_top";
  return_to?: string;
}

export const HelpCenterForm = React.forwardRef(({ target, return_to }: HelpCenterFormProps, ref) => {
  const formRef = useRef(null);
  const inputRef = useRef(null);

  const handleSubmit = () => {
    inputRef.current.value = HelpCenter.get();
    formRef.current.submit();
  }

  useImperativeHandle(ref, () => ({
    triggerSubmit: () => handleSubmit(),
    triggerFetch: () => {
      return fetchHelpCentreJwt();
    }})
  );

  return (
    <form ref={formRef} target={target} action="https://airtrail.zendesk.com/access/jwt" method="POST">
      <input ref={inputRef} type="hidden" name="jwt" />
      {!!return_to && (
        <input type="hidden" name="return_to" value={return_to} />
      )}
    </form>
  )
});

export default function HelpCenterButton({isIconOnly}: HelpCentreButtonProps) {
  const [isLoading, setIsLoading] = React.useState(false);
  const ref = useRef(null);

  const onClick = async () => {
    setIsLoading(true);
    if (!await ref.current?.triggerFetch()) {
      notification.error({
        message: 'Error',
        description: 'Failed to authenticate with Help Center. Please try again later or contact Air Trail support.',
      });

      setIsLoading(false);
      return;
    }
    ref.current?.triggerSubmit();
    setIsLoading(false);
  }

  return (
    <>
      <HelpCenterForm ref={ref} target="_blank" />
      <div style={{textAlign: 'center'}}>
        <Button
          type="text"
          loading={isLoading}
          icon={<HelpCenterButtonIcon />}
          onClick={onClick}
          size='large'
          style={{ color: '#fff'}}
        >
          {!isIconOnly && "Help Center"}
        </Button>
      </div>
    </>
)
}

type HelpCentreButtonProps = {
  ghost?: boolean;
  isIconOnly?: boolean;
};
